import {useMutation} from '@apollo/react-hooks';

import type {
    EntitySummaryRateInput,
    RateEntitySummary as RateEntitySummaryMutation,
    RateEntitySummaryVariables as RateEntitySummaryMutationVariables,
} from 'nutshell-graphql-types';

import {nutApolloClient} from '../../../../../apollo-client';

import ENTITY_SUMMARY_FRAGMENT from '../fragments/entity-summary-fragment.graphql';
import RATE_ENTITY_SUMMARY from '../mutations/rate-entity-summary.graphql';

export const useRateEntitySummary = (): {
    rateEntitySummary: (input: EntitySummaryRateInput) => Promise<any>;
    isSavingRating: boolean;
} => {
    const [rateEntitySummary, {loading}] = useMutation<
        RateEntitySummaryMutation,
        RateEntitySummaryMutationVariables
    >(RATE_ENTITY_SUMMARY);

    return {
        rateEntitySummary: (input: EntitySummaryRateInput) => {
            const entitySummary =
                input.entitySummaryId &&
                nutApolloClient.readFragment({
                    id: input.entitySummaryId,
                    fragment: ENTITY_SUMMARY_FRAGMENT,
                });

            return rateEntitySummary({
                variables: {input},
                optimisticResponse: entitySummary
                    ? {
                          // @ts-expect-error
                          __typename: 'Mutation',
                          entitySummaryRate: {
                              __typename: 'EntitySummaryRatePayload',
                              entitySummary: {
                                  ...entitySummary,
                                  userRating: input.rating,
                              },
                          },
                      }
                    : undefined,
            });
        },
        isSavingRating: loading,
    };
};
